import clsx from 'clsx';
import { SyntheticEvent, useState } from 'react';
import { useUser } from '../../contexts/UserContext';
import { UserMenu } from './UserMenu';
import { Person } from '@material-ui/icons';
import { MenuDivider } from '../Navigation/MenuDivider';
import { Button } from '../Button/NewButton';

interface Props {
  isDarkMode: boolean;
  isMobile: boolean;
  setDarkMode(value: boolean): void;
}

export const UserPreferences = ({
  isDarkMode,
  isMobile,
  setDarkMode,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const user = useUser();

  if (user === undefined) return null;

  return (
    <>
      <MenuDivider isMobile={isMobile} />
      <div
        className={clsx('flex', {
          'flex-col items-center w-full': isMobile,
          'flex-row w-fit': !isMobile,
        })}
      >
        <Button
          className="text-white hover:!text-primary !px-4"
          color="white"
          onClick={(e: SyntheticEvent<HTMLElement>) =>
            setAnchorEl(e.currentTarget)
          }
          theme="text"
          aria-label="Profile"
          aria-haspopup="true"
          startIcon={<Person />}
          disabled={user.loading}
        >
          {user.email?.split('@')[0]}
        </Button>

        <UserMenu
          anchorEl={anchorEl}
          isDarkMode={isDarkMode}
          onClose={() => setAnchorEl(null)}
          setDarkMode={setDarkMode}
          user={user}
        />
      </div>
    </>
  );
};
